import {
  Alert,
  Box,
  Button,
  Card,
  Checkbox,
  CircularProgress,
  Container,
  FormControl,
  MenuItem,
  Pagination,
  Paper,
  Select,
  Snackbar,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React, { useEffect, useState } from 'react';
import FotaMoreMenu from '../components/_dashboard/smartlock/FotaMoreMenu';
import NoDataAvailable from '../components/_dashboard/smartlock/NoDataAvailable';
import SelectFotaVersionToApply from '../components/_dashboard/smartlock/SelectFotaVersionToApply';
import Header from '../components/navbar/Header';
import Page from '../components/Page';
import { HeaderHeight, PageHeaderHeight } from '../Constants';
import { GetFotaLogs, GetVersionList } from '../network/Fota';

const useStyles = makeStyles((theme) => ({
  menuItem: {
    fontSize: '14px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px'
    },
    minHeight: '20px',
    borderRadius: '8px',
    marginInline: theme.spacing(1)
  },
  tableCellStyle: {
    fontSize: {
      xs: '12px',
      md: '14px'
    },
    fontWeight: 700,
    padding: {
      xs: '8px',
      md: '16px'
    },
    backgroundColor: '#FFFFFF'
  },
  tablePaper: {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    backgroundColor: '#FFFFFF'
  },
  tableContainer: {
    flexGrow: 1,
    height: `calc(100vh - ${HeaderHeight + PageHeaderHeight + 56 + 40}px)`,
    overflow: 'auto'
  }
}));

const LoaderContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '50px'
});
const PageHeader = styled('Box')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'start',
  gap: 1,
  flexDirection: 'row !important',
  height: '50px'
}));

export default function FotaLogs() {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [fotaLogsList, setFotaLogsList] = useState([]);
  const [isFotaVersionModalOpen, setIsFotaVersionModalOpen] = useState(false);
  const [selectedDeviceData, setSelectedDeviceData] = useState(null);
  const [fotaVersionList, setFotaVersionList] = useState([]);
  const [filterVersion, setFilterVersion] = useState('');
  const [selectedRows, setSelectedRows] = useState([]);
  const [alertMetas, setAlertMetas] = useState({
    snackBarOpened: false,
    vertical: 'top',
    horizontal: 'right',
    msg: '',
    variant: 'filled',
    severity: ''
  });

  const vertical = 'bottom';
  const horizontal = 'left';

  // const handleSnackBarClose = (event, reason) => {
  //   setAlertMetas({ ...alertMetas, snackBarOpened: false });
  // };

  const isAllSelected =
    fotaLogsList?.data?.length > 0 && selectedRows.length === fotaLogsList.data.length;

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleLogSearch = (value) => {
    setSearch(value);
  };
  const searchFotaLogs = () => {
    setPage(1);
    getAllFotaLogs(page, search);
  };

  // const handleFilterChange = (e) => {
  //   setFilterVersion(e.target.value);
  // };

  const handleFotaMoreMenuClick = (action, data) => {
    switch (action) {
      case 'apply_fota':
        setSelectedDeviceData(data);
        setIsFotaVersionModalOpen(true);
        break;

      default:
        break;
    }
  };

  const onAddFotaModalAction = (d) => {
    getAllFotaLogs(page, search);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const allIds = fotaLogsList?.data?.map((item) => item?.lock_id);
      setSelectedRows(allIds);
    } else {
      setSelectedRows([]);
    }
  };

  const handleCheckboxClick = (id) => {
    const selectedIndex = selectedRows.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = [...selectedRows, id];
    } else {
      newSelected = selectedRows?.filter((selectedId) => selectedId !== id);
    }

    setSelectedRows(newSelected);
  };

  const getFotaVersionList = async () => {
    try {
      const res = await GetVersionList();
      setFotaVersionList(res?.data?.data);
    } catch (error) {
      console.error(error, 'Error fetching FOTA versions');
    }
  };

  const getAllFotaLogs = async (page, search) => {
    setLoader(true);
    try {
      const res = await GetFotaLogs(page, search);
      setFotaLogsList(res?.data);
    } catch (error) {
      console.error(error, 'Error fetching FOTA logs');
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getFotaVersionList();
  }, []);

  useEffect(() => {
    getAllFotaLogs(page, search);
  }, [page, search]);

  return (
    <Page title="FOTA">
      <Header
        onOpenSidebar={() => setOpen(true)}
        handleSearch={handleLogSearch}
        handleSubmit={searchFotaLogs}
        name="FOTA Logs Management"
        showSearch
      />
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={alertMetas?.snackBarOpened}
        // onClose={handleSnackBarClose}
        autoHideDuration={6000}
      >
        <Alert variant={alertMetas?.variant} severity={alertMetas?.severity}>
          {alertMetas?.msg}
        </Alert>
      </Snackbar>
      <Container maxWidth="false" disableGutters sx={{ padding: 0 }}>
        <PageHeader>
          <Button
            variant="outlined"
            size="medium"
            disabled={selectedRows?.length === 0}
            sx={{ backgroundColor: '#FFFFFF', boxShadow: '0px 10px 19px 1px #EAEAFF' }}
            onClick={() => setIsFotaVersionModalOpen(true)}
          >
            Apply FOTA
          </Button>
          {/* <FormControl size="small" sx={{ minWidth: { xs: 130, sm: 150 } }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Typography sx={{ fontSize: { xs: '12px', sm: '14px' }, fontWeight: 600 }}>
                Filter By
              </Typography>
              <Select
                sx={{
                  fontSize: { xs: '12px', sm: '14px' },
                  fontWeight: '500',
                  minWidth: '130px',
                  borderRadius: '12px'
                }}
                labelId="role-filter-select-label"
                id="role-filter-select"
                value={filterVersion}
                onChange={handleFilterChange}
                IconComponent={ExpandMoreIcon}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 180,
                      overflowY: 'auto'
                    }
                  }
                }}
              >
                {fotaVersionList?.map((item) => (
                  <MenuItem
                    value={item?.id}
                    key={item?.id}
                    className={classes.menuItem}
                    sx={{ textTransform: 'capitalize' }}
                  >
                    {item?.name}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          </FormControl> */}
        </PageHeader>
        <Card sx={{ width: '100%' }}>
          <Paper className={classes.tablePaper}>
            <TableContainer data-testid="fota-data-table" className={classes.tableContainer}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <TableCell padding="checkbox" className={classes.tableCellStyle} width={50}>
                      <Checkbox
                        data-testid="master-checkbox-fotaApply"
                        indeterminate={
                          selectedRows.length > 0 &&
                          selectedRows.length < fotaLogsList?.data?.length
                        }
                        checked={isAllSelected}
                        onChange={handleSelectAllClick}
                      />
                    </TableCell>
                    <TableCell className={classes.tableCellStyle} width={100}>
                      Name
                    </TableCell>
                    <TableCell className={classes.tableCellStyle} width={100}>
                      Latest Version
                    </TableCell>
                    <TableCell className={classes.tableCellStyle} width={100}>
                      Last version
                    </TableCell>
                    <TableCell className={classes.tableCellStyle} width={100}>
                      Status
                    </TableCell>
                    <TableCell className={classes.tableCellStyle} width={100}>
                      Last Update
                    </TableCell>
                    <TableCell className={classes.tableCellStyle} width={100} />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loader && (
                    <TableRow>
                      <TableCell colSpan={10}>
                        <LoaderContainer>
                          <CircularProgress size={30} />
                        </LoaderContainer>
                      </TableCell>
                    </TableRow>
                  )}

                  {!loader && fotaLogsList?.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={10}>
                        <NoDataAvailable />
                      </TableCell>
                    </TableRow>
                  )}

                  {!loader &&
                    fotaLogsList?.data?.length > 0 &&
                    fotaLogsList.data.map((item) => {
                      const isItemSelected = selectedRows.includes(item.lock_id);
                      return (
                        <TableRow key={item?.id}>
                          <TableCell padding="checkbox">
                            <Checkbox
                              checked={isItemSelected}
                              onChange={() => handleCheckboxClick(item?.lock_id)}
                            />
                          </TableCell>
                          <TableCell
                            align="left"
                            sx={{
                              textTransform: 'capitalize',
                              minWidth: '5vw',
                              textWrap: 'nowrap',
                              padding: { xs: '8px', md: '16px' },
                              fontSize: { xs: '12px', md: '14px' }
                            }}
                          >
                            {item?.name}
                          </TableCell>
                          <TableCell
                            sx={{
                              minWidth: '5vw',
                              textWrap: 'nowrap',
                              padding: { xs: '8px', md: '16px' },
                              fontSize: { xs: '12px', md: '14px' }
                            }}
                            align="left"
                          >
                            {item?.version}
                          </TableCell>
                          <TableCell
                            align="left"
                            sx={{
                              textTransform: 'capitalize',
                              minWidth: '5vw',
                              textWrap: 'nowrap',
                              padding: { xs: '8px', md: '16px' },
                              fontSize: { xs: '12px', md: '14px' }
                            }}
                          >
                            {item?.lastversion}
                          </TableCell>
                          <TableCell
                            sx={{
                              minWidth: '5vw',
                              textWrap: 'nowrap',
                              textTransform: 'capitalize',
                              padding: { xs: '8px', md: '16px' },
                              fontSize: { xs: '12px', md: '14px' }
                            }}
                            align="left"
                          >
                            {item?.status}
                          </TableCell>
                          <TableCell
                            align="left"
                            sx={{
                              textTransform: 'capitalize',
                              minWidth: '5vw',
                              textWrap: 'nowrap',
                              padding: { xs: '8px', md: '16px' },
                              fontSize: { xs: '12px', md: '14px' }
                            }}
                          >
                            {item?.createdAt}
                          </TableCell>
                          <TableCell
                            sx={{
                              minWidth: '5vw',
                              textWrap: 'nowrap',
                              textTransform: 'capitalize',
                              padding: { xs: '8px', md: '16px' },
                              fontSize: { xs: '12px', md: '14px' }
                            }}
                            align="right"
                          >
                            <FotaMoreMenu handleClicks={(e) => handleFotaMoreMenuClick(e, item)} />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>

            {fotaLogsList?.data?.length !== 0 && (
              <Stack
                sx={{
                  marginTop: '10px',
                  marginBottom: '10px'
                }}
              >
                <Pagination
                  style={{ display: 'flex', justifyContent: 'flex-end' }}
                  count={fotaLogsList?.totalPages}
                  showFirstButton
                  showLastButton
                  onChange={handlePageChange}
                  page={page}
                  total={fotaLogsList?.total}
                />
              </Stack>
            )}
          </Paper>
        </Card>
      </Container>
      {isFotaVersionModalOpen && (
        <SelectFotaVersionToApply
          openAssignedModal={isFotaVersionModalOpen}
          handleClose={() => setIsFotaVersionModalOpen(false)}
          deviceData={selectedDeviceData}
          setSelectedDeviceData={setSelectedDeviceData}
          versionList={fotaVersionList}
          onAction={(d) => onAddFotaModalAction(d)}
          setAlertMetas={setAlertMetas}
          alertMetas={alertMetas}
          selectedIds={selectedRows}
          setSelectedIds={setSelectedRows}
        />
      )}
    </Page>
  );
}
